import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC] px-4">
      <div className="w-full max-w-md rounded-3xl border border-slate-200 bg-white p-10 text-center shadow-sm">
        <XCircle className="mx-auto h-10 w-10 text-slate-400" />
        <h1 className="mt-4 font-heading text-2xl font-bold text-[#0F2747]">Checkout canceled</h1>
        <p className="mt-2 text-slate-500">No charge was made. You can upgrade to Pro whenever you're ready.</p>
        <Button data-testid="cancel-back-btn" onClick={() => navigate("/upgrade")} className="mt-6 w-full rounded-full bg-[#18A6A6] py-6 hover:bg-[#148f8f]">Back to upgrade</Button>
      </div>
    </div>
  );
}
